import type { Address } from 'viem';

import { Web3Raffle__factory } from '@shared/config/contracts/abi-typed';

const RAFFLE_CONTRACT_ADDRESS_BSC: Address =
  (process.env.NEXT_PUBLIC_RAFFLE_CONTRACT_ADDRESS_BSC as Address) ?? '0x0';

export const RAFFLE_CONTRACT = {
  abi: Web3Raffle__factory.abi,
  address: RAFFLE_CONTRACT_ADDRESS_BSC,
};
